export default "__VITE_ASSET__8c5527bf__"